import { ReferenceData } from '@/App/apiWrapper';
import { CodeTableRef } from '@/App/types';
import { ScreenRef } from '@/App/types/screenRef';

export type RefData = {
  [key in CodeTableRef]?: ReferenceData[];
};

export type ScreenRefDataMap = {
  [key in ScreenRef]?: RefData;
};

export interface RefDataState {
  screenRefDataMap: ScreenRefDataMap;
  refresh: boolean;
}

export const initialState: RefDataState = {
  screenRefDataMap: {},
  refresh: false,
};
